function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: -163.1,
  cy: 397.2,
  r: 30.7,
  fill: "#fcd51b"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M-122.7 359.9l-11.9 11.9c-1 1-2.5 1-3.5 0s-1-2.5 0-3.5l11.9-11.9c1-1 2.5-1 3.5 0s1 2.6 0 3.5zm-77.5-3.1l11.9 11.9c1 1 1 2.5 0 3.5s-2.5 1-3.5 0l-11.9-11.9c-1-1-1-2.5 0-3.5s2.6-1 3.5 0zm11.9 69.3l-11.9 11.9c-1 1-2.5 1-3.5 0s-1-2.5 0-3.5l11.9-11.9c1-1 2.5-1 3.5 0s1 2.6 0 3.5zm27.4-83.9V359c0 1.4-1.1 2.5-2.5 2.5s-2.5-1.1-2.5-2.5v-16.8c0-1.4 1.1-2.5 2.5-2.5s2.5 1.2 2.5 2.5zm-57.3 52.8h16.8c1.4 0 2.5 1.1 2.5 2.5s-1.1 2.5-2.5 2.5h-16.8c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5zm92.1 42.6l-11.9-11.9c-1-1-1-2.5 0-3.5s2.5-1 3.5 0l11.9 11.9c1 1 1 2.5 0 3.5s-2.6 1-3.5 0zm-39.3 14.6v-16.8c0-1.4 1.1-2.5 2.5-2.5s2.5 1.1 2.5 2.5v16.8c0 1.4-1.1 2.5-2.5 2.5s-2.5-1.2-2.5-2.5zm57.3-52.8h-16.8c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5h16.8c1.4 0 2.5 1.1 2.5 2.5s-1.1 2.5-2.5 2.5z",
  fill: "#ec6d27"
});

function SvgSun(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-234 333.4 141.7 127.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.8f1aa754.svg";
export { ForwardRef as ReactComponent };